module.exports = [{"type":"title","text":"2024-05-27"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續新增接口：訂閱所有幣對24小時價格變動"},{"type":"html","text":"永續新增接口：訂閱合約所有幣對k線數據"},{"type":"html","text":"永續新增接口：訂閱所有幣對有限檔深度信息"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-05-27.json
// module id = 5LYy
// module chunks = 3